import { AppointmentStatus } from '../../appointments/enums/appointment-status.enum.js';
import { AttendanceOutcome } from '../../appointments/enums/attendance-outcome.enum.js';
const BLOCKING_APPOINTMENT_STATUSES = [
    AppointmentStatus.CANCELLED,
    AppointmentStatus.NO_SHOW,
];
const BLOCKING_ATTENDANCE = [
    AttendanceOutcome.CANCELLED,
    AttendanceOutcome.NO_SHOW,
];
/**
 * Rule 3.2-1 (Spec § 3.2): a dictation is possible when the appointment has
 * started (`scheduledStart ≤ now`), the appointment is neither cancelled nor a
 * no-show, and this patient's own attendance is neither cancelled nor a
 * no-show. Unconfirmed past appointments (`SCHEDULED`,
 * `AWAITING_CONFIRMATION`, `LAPSED`) qualify — the Termin-Detail nudge fires
 * right after „Stattgefunden", but documenting must not wait for it.
 *
 * Pure and shared: the overview marks each card with it, the create handler
 * re-checks it, the UI never has to guess.
 */
export const isDictationAllowed = (input) => {
    const start = new Date(input.scheduledStart).getTime();
    if (Number.isNaN(start))
        return false;
    const now = (input.now ?? new Date()).getTime();
    if (start > now)
        return false;
    if (BLOCKING_APPOINTMENT_STATUSES.includes(input.appointmentStatus))
        return false;
    if (input.attendance !== null && BLOCKING_ATTENDANCE.includes(input.attendance))
        return false;
    return true;
};
//# sourceMappingURL=is-dictation-allowed.js.map